import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MAT_SNACK_BAR_DATA } from '@angular/material';

@Component({
    selector: 'app-success-toast',
    template: `<div class="text-center">
    <i class="fa fa-check-circle-o text-center md-pt-15"></i>
    <p style="padding: 10px 20px;" class="md-mt-0 md-mb-10">{{title}}</p>
    <!-- <div class="md-mt-10">
        <button class="btn btn-space btn-primary" (click)="cancel()">OK</button>
    </div> -->
</div>`,
    styles: [
      `span {
        color: #749e18;
        float: right;
        font-size: 20px;
      }
      .fa-check-circle-o {
        font-size: 48px;
        color: green;
      }`]
})
export class SuccessToastComponent {

  public title = 'Success!'

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {
    if(this.data && this.data.message){
      this.title = this.data.message;
    }
  }

  // cancel() {
  //   this.dialogRef.close('Cancel');
  // }
}


